
import Vue from 'vue';
import { Source } from '@root/common/types/fragment';

interface Props {
  sources: Array<any>;
}

interface Computed {
  source: Source;
  description: string | null;
}

export default Vue.extend<unknown, Computed, unknown, Props>({
  props: {
    sources: {
      type: Array,
      required: true,
    },
  },
  computed: {
    source() {
      return this.sources[0];
    },
    description() {
      return this.source.description || this.source.disclaimer;
    },
  },
});
